import React, { useState } from 'react';
import {
    Container,
    Typography,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Paper,
    Grid,
    Button,
    Box,
    Snackbar,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import WarningIcon from '@mui/icons-material/Warning';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { CalificarGroup, GetActivityDataAPI, GetEstudentsArrayDataAPI, GetPointsDataAPI } from '../../Conections/AcademicConection';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Datos de ejemplo
const actividadEjemplo = {
    id: '0',
    nombre: "",
    descripcion: "",
    fecha: "",
    peso: 0,
    grupo: ""
};

const estudiantesEjemplo = [
    { id: 0, codigo: '', nombre: "", apellido: "" }
];

const puntosEjemplo = [
    { id: 0, nombre: "", peso: 0 }
];

function GradeUpComplete() {

    const location = useLocation();
    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [actividad, setActividad] = useState(actividadEjemplo);
    const [estudiantes, setEstudiantes] = useState(estudiantesEjemplo);
    const [actividadTitle, setActividadTitle] = useState("");
    const [actividadNote, setActividadNote] = useState(0);
    const [puntos, setPuntos] = useState(puntosEjemplo);
    const [calificaciones, setCalificaciones] = useState(
        puntos.reduce((acc, punto) => ({
            ...acc,
            [punto.id]: { id: punto.id, valor: '', razon: '' }
        }), {})
    );
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [openDialog, setOpenDialog] = useState(false);
    const [errors, setErrors] = useState({});

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/gradeupone/:activity");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
                else {
                    const estuduantesSelect = location.state?.idsSeleccionados || [];
                    let Activity = await GetActivityDataAPI(getToken(), getCompany(), params["activity"]);

                    let Estudents = await GetEstudentsArrayDataAPI(getToken(), getCompany(), Activity["group"], estuduantesSelect);
                    console.log(Estudents);

                    let Points = await GetPointsDataAPI(getToken(), getCompany(), params["activity"]);

                    let actividadChange = actividad;
                    actividadChange["id"] = Activity["id"];
                    setActividadTitle(Activity["name"]);
                    actividadChange["nombre"] = Activity["name"];
                    actividadChange["descripcion"] = Activity["description"];
                    actividadChange["peso"] = Activity["weigth"];
                    actividadChange["fecha"] = Activity["date"];
                    actividadChange["activa"] = Activity["show"] === 1;
                    setActividad(actividadChange);

                    const listEstudents = Estudents.map(Estudent => ({
                        id: Estudent.id,
                        codigo: Estudent.code,
                        nombre: Estudent.firstname,
                        apellido: Estudent.lastname
                    }));
                    setEstudiantes(listEstudents);

                    const listPoint = Points.map(Point => ({
                        id: Point.id,
                        nombre: Point.text,
                        peso: Point.weigth,
                    }));
                    setPuntos(listPoint);
                    setCalificaciones(listPoint.reduce((acc, punto) => ({
                        ...acc,
                        [punto.id]: { id: punto.id, valor: '', razon: '' }
                    }), {}));
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [params, actividad, getCompany, getToken, goTo, actividadTitle, location]);

    const handleCalificacionChange = (puntoId, valor) => {
        const numeroValor = Number(valor);
        if (isNaN(numeroValor) || numeroValor < 0 || numeroValor > 100) return;

        setCalificaciones(prevCalificaciones => ({
            ...prevCalificaciones,
            [puntoId]: { ...prevCalificaciones[puntoId], valor }
        }));
        setErrors(prevErrors => ({ ...prevErrors, [puntoId]: { valor: false } }));
    };

    const handleRazonChange = (puntoId, razon) => {
        setCalificaciones(prevCalificaciones => ({
            ...prevCalificaciones,
            [puntoId]: { ...prevCalificaciones[puntoId], razon }
        }));
        setErrors(prevErrors => ({ ...prevErrors, [puntoId]: { ...prevErrors[puntoId], razon: false } }));
    };

    const handleEnviarCalificaciones = async () => {
        const newErrors = {};
        let hasErrors = false;

        Object.entries(calificaciones).forEach(([puntoId, { valor, razon }]) => {
            console.log(calificaciones);
            newErrors[puntoId] = {};
            if (valor.trim() === '') {
                newErrors[puntoId].valor = true;
                hasErrors = true;
            }
            if (razon.trim() === '') {
                newErrors[puntoId].razon = true;
                hasErrors = true;
            }
        });

        setErrors(newErrors);

        if (hasErrors) {
            setSnackbarMessage('Por favor, complete todos los campos antes de enviar.');
            setSnackbarSeverity('error');
            setOpenSnackbar(true);
        } else {
            const estuduantesSelect = location.state?.idsSeleccionados || [];
            const datos = await CalificarGroup(
                getToken(),
                getCompany(),
                params["activity"],
                estuduantesSelect,
                calificaciones
            );
            console.log(puntos);
            console.log(calificaciones);
            let promedioPonderado = "";
            
            let datos1 = Number(datos);

            if (!isNaN(datos1) && typeof datos1 === 'number') {
                // Variables para sumar
                let sumaMultiplicaciones = 0;
                let sumaPesos = 0;

                puntos.forEach((punto) => {
                    const nota = calificaciones[punto.id];

                    if (nota) {
                        const peso = punto.peso;
                        const valor = parseFloat(nota.valor); // Convertir a número

                        sumaMultiplicaciones += peso * valor;
                        sumaPesos += peso;
                    }
                });

                // Calcular el promedio ponderado
                promedioPonderado = sumaPesos > 0 ? Math.round((sumaMultiplicaciones / sumaPesos) / 2) : 0;
                setActividadNote(promedioPonderado);
            }
            else {
                promedioPonderado = "No se pudo almacenar";
            }
            setActividadNote(promedioPonderado);
            setOpenDialog(true);
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
                Ingresar Calificación Grupal
            </Typography>

            <Grid container spacing={3} direction="column">
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Datos de la Actividad
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {actividad.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Descripción:</strong> {actividad.descripcion}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Fecha:</strong> {actividad.fecha}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Peso:</strong> {actividad.peso}%
                            </Typography>
                            <Typography variant="body1">
                                <strong>Grupo:</strong> {actividad.grupo}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Lista de Estudiantes
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Apellido</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {estudiantes.map((estudiante) => (
                                            <TableRow key={estudiante.id}>
                                                <TableCell>{estudiante.codigo}</TableCell>
                                                <TableCell>{estudiante.nombre}</TableCell>
                                                <TableCell>{estudiante.apellido}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Ingresar Calificación Grupal
                            </Typography>
                            <Typography variant="body2" paragraph>
                                La calificación ingresada se aplicará a todos los miembros del grupo.
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Criterio</TableCell>
                                            <TableCell align="center">Peso</TableCell>
                                            <TableCell align="center">Calificación (0-100)</TableCell>
                                            <TableCell align="center">Razón</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {puntos.map((punto) => (
                                            <TableRow key={punto.id}>
                                                <TableCell>{punto.nombre}</TableCell>
                                                <TableCell align="center">{punto.peso}%</TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        type="number"
                                                        InputProps={{
                                                            inputProps: {
                                                                min: 0,
                                                                max: 100,
                                                                step: 1
                                                            }
                                                        }}
                                                        value={calificaciones[punto.id].valor}
                                                        onChange={(e) => handleCalificacionChange(punto.id, e.target.value)}
                                                        variant="outlined"
                                                        size="small"
                                                        sx={{ width: '100px' }}
                                                        error={errors[punto.id]?.valor}
                                                        helperText={errors[punto.id]?.valor ? "Campo requerido" : ""}
                                                    />
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField
                                                        multiline
                                                        rows={2}
                                                        value={calificaciones[punto.id].razon}
                                                        onChange={(e) => handleRazonChange(punto.id, e.target.value)}
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        placeholder="Ingrese la razón de la calificación"
                                                        error={errors[punto.id]?.razon}
                                                        helperText={errors[punto.id]?.razon ? "Campo requerido" : ""}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleEnviarCalificaciones}
                                >
                                    Enviar Calificación
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ textAlign: 'center' }}
            >
                <DialogContent>
                {
                       (typeof actividadNote === 'string') ?<WarningIcon sx={{ fontSize: 60, color: 'warning.main', mb: 2 }} />:<></>
                    }
                    <DialogTitle id="alert-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
                        La nota es:
                    </DialogTitle>
                    <DialogContentText id="alert-dialog-description">
                        {actividadNote}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        onClick={() => goTo(`/academic/gradeupone/${params["activity"]}`)}
                        variant="contained"
                        color="success"
                        autoFocus
                    >
                        Continuar
                    </Button>
                    {
                       (typeof actividadNote === 'string') ?
                        <Button
                            onClick={handleEnviarCalificaciones}
                            variant="outlined"
                            color="error"
                        >
                            Reintentar
                        </Button>
                        :
                        <></>
                    }


                </DialogActions>
            </Dialog>
        </Container>
    );
}

export default GradeUpComplete;

